export type ScanImageCaptureConfig = {
  captureAtSeconds: number[];
  maxImages: number;
};

export const scanImageCaptureConfig: ScanImageCaptureConfig = {
  captureAtSeconds: [20],
  maxImages: 1,
};
